/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, ViewChild, ElementRef, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationError, NavigationCancel } from '@angular/router';

@Component({
	selector: 'loading-component',
	templateUrl: './loading.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingComponent implements OnInit {
	public shown = true;
	//Due to the nature of how the main thread gets block on state change to plan, we can't use ngIf
	@ViewChild('base', { static: true }) public base: ElementRef;

	constructor(private router: Router) {}

	public ngOnInit() {
		this.base.nativeElement.classList.add('show');
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationStart) {
				this.shown = true;
				this.base.nativeElement.classList.add('show');
			} else if (
				event instanceof NavigationEnd ||
				event instanceof NavigationCancel ||
				event instanceof NavigationError
			) {
				this.shown = false;
				this.base.nativeElement.classList.remove('show');
			}
		});
	}
}
